import { useMemo } from "react";
import resilenderLogo from "../../../../assets/resilender-logo.png"; // Adjust the path as necessary
import PdfColumn from "../components/layout/PdfColumn";
import PdfDivider from "../components/layout/PdfDivider";
import PdfRow from "../components/layout/PdfRow";
import PdfSection from "../components/layout/PdfSection";
import PdfPageTitle from "../components/typography/PdfPageTitle";
import PdfText from "../components/typography/PdfText";
import PdfBuilderLogo from "../ui/images/PdfBuilderLogo";
import { pdfBuilderGetTypeValue } from "../utils/pdfBuilderGetTypeValue";
import PdfPage from "./PdfPage";

const PdfPageBrandedSubmission = ({
  children,
  pageNumber,
  pageTitle,
  submittedBy,
  submittedDate,
  hideLogo = false,
}) => (
  <PdfPage>
    <PdfRow
      style={{
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 20,
      }}
    >
      {pageTitle && <PdfPageTitle>{pageTitle}</PdfPageTitle>}
      {hideLogo ? null : (
        <PdfBuilderLogo
          style={{ position: "absolute", top: -10, right: -10 }}
          src={resilenderLogo}
          size={32}
        />
      )}
    </PdfRow>
    {children}

    <PdfFooter>
      <PdfRow style={{ justifyContent: "space-between" }}>
        <FootSubmissionDetails
          submittedBy={submittedBy}
          submittedDate={submittedDate}
        />
        <PdfText variant={"small"}>Page {pageNumber}</PdfText>
      </PdfRow>
    </PdfFooter>
  </PdfPage>
);

const PdfFooter = ({ children, style }) => {
  const styles = useMemo(() => {
    return {
      position: "absolute",
      bottom: -15,
      left: 0,
      width: "100%",
      padding: 20,
      color: "#666666",
      ...style,
    };
  }, [style]);
  return (
    <PdfSection style={styles}>
      <PdfDivider />
      {children}
    </PdfSection>
  );
};

const FootSubmissionDetails = ({ submittedBy, submittedDate }) => {
  if (!submittedBy || !submittedDate) {
    return null;
  }
  return (
    <PdfColumn>
      {submittedDate && (
        <PdfText variant={"small"} style={{ marginBottom: 2 }}>
          Submitted: {pdfBuilderGetTypeValue(submittedDate, "date")}
        </PdfText>
      )}
      {submittedBy && (
        <PdfText variant={"small"}>Applicant: {submittedBy}</PdfText>
      )}
    </PdfColumn>
  );
};

export default PdfPageBrandedSubmission;
